export const REQUIRED = 'Campo obrigatório';
export const TOO_SHORT = (error) => `Digite no mínimo ${error.min} caracteres`;
export const TOO_LONG = (error) => `Digite no máximo ${error.max} caracteres`;
export const VALID_CNPJ = () => '';
export const DATE = 'Data inválida';
export const EMAIL = 'O e-mail digitado é inválido.';
